<template>
  <div id="lost-view">
    <h1>Cette page n'a pas été trouvée</h1>
    <h4>Nous sommes désolés, mais la page demandée est introuvable.</h4>
    <router-link to="/">Retour à l'accueil</router-link>
  </div>
</template>

<script>
export default {
  name: 'Lost',
  created () {
    var app = this
    app.$store.dispatch('routing/update_title', 'Page introuvable')
    app.$store.dispatch('routing/update_return_kwargs', null)
  }
}
</script>

<style scoped lang="scss">
#lost-view {
  height: 60vh;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/views/Lost.vue